module.exports = __webpack_public_path__ + "img/DE00798.b6c80ffd.png";